export function isEmpty(object) {
    return Boolean(object) && Boolean(Object.keys(object).length);
}

//# sourceMappingURL=object-utils.js.map